import { render, staticRenderFns } from "./SupplementInfoModal.vue?vue&type=template&id=0b53231b&scoped=true"
import script from "./SupplementInfoModal.vue?vue&type=script&lang=js"
export * from "./SupplementInfoModal.vue?vue&type=script&lang=js"
import style0 from "./SupplementInfoModal.vue?vue&type=style&index=0&id=0b53231b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b53231b",
  null
  
)

export default component.exports